import ClubGoalsReport from './ClubGoalsReport';

export default ClubGoalsReport;

